// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OrcamentosServicos_SalvaOrcamentoServicoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /orcamentos_servicos/salvaOrcamentoServico
 *
 * Returns the saved/updated orcamento_servico record.
 */
import type { OrcamentosServicos_SalvaOrcamentoServicoRow } from './OrcamentosServicos_SalvaOrcamentoServicoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface OrcamentosServicos_SalvaOrcamentoServicoResponseDados {
dados: OrcamentosServicos_SalvaOrcamentoServicoRow
}

export type OrcamentosServicos_SalvaOrcamentoServicoResponse = ApiResponse<OrcamentosServicos_SalvaOrcamentoServicoResponseDados>;

registerResponseContract('OrcamentosServicos_SalvaOrcamentoServicoResponse', {
  dados: {
    type: 'object',
    required: true,
    fields: {
      orcamento_servico_id:            { type: 'number',  required: true },
      orcamento_id:                    { type: 'number',  required: true },
      servico_id:                      { type: 'number',  required: true },
      servico_valor:                   { type: 'number',  required: true },
      orcamento_servico_qtd:           { type: 'number',  required: false },
      orcamento_servico_status:        { type: 'number',  required: false },
      orcamento_servico_tipo:          { type: 'number',  required: false },
      orcamento_servico_user_id:       { type: 'string',  required: false },
      orcamento_servico_data_cadastro: { type: 'string',  required: false },
    },
  },
})
